import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class PrivateSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('[data-js="private-slide"]'),
    this.dom.slides = this.dom.slider.querySelectorAll('.splide__slide');

    this.slider = null;

    this.option = {
      autoplay: true,
      // autoWidth: true,
      focus: 'center',
      type: 'loop',
      rewind: true,
      perPage: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      drag: false,
      interval: 5000,
      speed: 2000,
      arrows: false,
      pagination: false,
      padding: `${30 / 375 * 100}vw`,
      gap: `${30 / 375 * 100}vw`,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          padding: `${216 / 1440 * 100}vw`,
          gap: `${36 / 1440 * 100}vw`,
        }
      }
    };

    console.log(this.dom.slides)
    if (this.dom.slides.length > 1) this.init();
  }

  init() {

    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
  }
}

export default PrivateSlides